import _ from 'lodash';
import React from 'react';
import {findDOMNode} from 'react-dom';
import shallowCompare from '../../lib/shallowCompare';
import PhotoHash from '../../models/PhotoHash';

const TagTypes = {
  img: 'img',
  div: 'div'
};

class Image extends React.Component {
  static propTypes = {
    className: React.PropTypes.string,
    loading: React.PropTypes.bool,
    tag: React.PropTypes.string,
    aspectRatio: React.PropTypes.number,
    mobileAspectRatio: React.PropTypes.number,
    targetWidth: React.PropTypes.number,
    photoHash: React.PropTypes.instanceOf(PhotoHash).isRequired,
    transition: React.PropTypes.string,
    borderRadius: React.PropTypes.string,
    children: React.PropTypes.element
  };

  static defaultProps = {
    className: '',
    loading: false,
    tag: TagTypes.img,
    aspectRatio: 1,
    mobileAspectRatio: null,
    transition: 'opacity 0.1s ease-in',
    borderRadius: '4px'
  };

  static contextTypes = {
    getUserAgent: React.PropTypes.func
  };

  constructor(props) {
    super(props);

    this.state = this.getStateFromProps(props);
  }

  componentDidMount() {
    this.preloadImages();
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  componentWillReceiveProps(nextProps) {
    this.setState(this.getStateFromProps(nextProps));
  }

  componentDidUpdate(prevProps, prevState) {
    this.preloadImages();
  }

  componentWillUnmount() {
    if(this.fullResPreloaderImg) {
      this.fullResPreloaderImg.onload = null;
    }
    if(this.lowResPreloaderImg) {
      this.lowResPreloaderImg.onload = null;
    }
  }

  getStateFromProps(props) {
    let fullResUrl = props.photoHash.getClosestToTarget(props.targetWidth);
    let lowResUrl = fullResUrl;
    if(props.targetWidth > 640) {
      lowResUrl = props.photoHash.getClosestToTarget(50);
    }

    return {
      fullResLoaded: false,
      lowResLoaded: false,
      lowResUrl: lowResUrl,
      fullResUrl: fullResUrl
    };
  }

  preloadImages() {
    // Load low-res
    if(this.state.lowResUrl !== this.state.fullResUrl) {
      this.lowResPreloaderImg = new window.Image();
      this.lowResPreloaderImg.onload = () => {
        this.setState({lowResLoaded: true});
      };
      this.lowResPreloaderImg.src = this.state.lowResUrl;
      this.setState({lowResLoaded: this.lowResPreloaderImg.complete});
    }
    // Load full-res
    this.fullResPreloaderImg = new window.Image();
    this.fullResPreloaderImg.onload = () => {
      this.setState({fullResLoaded: true});
    };
    this.fullResPreloaderImg.src = this.state.fullResUrl;
    this.setState({fullResLoaded: this.fullResPreloaderImg.complete});
  }

  render() {
    this.isMobile = this.isMobile || this.context.getUserAgent().isMobile;
    let { className, photoHash, targetWidth, aspectRatio } = this.props;
    let { lowResUrl, fullResUrl, lowResLoaded, fullResLoaded } = this.state;

    let loaded = !this.props.loading && (fullResLoaded || lowResLoaded);

    if(this.props.mobileAspectRatio && this.isMobile) {
      aspectRatio = this.props.mobileAspectRatio;
    }

    if(this.props.tag === TagTypes.img) {
      let url = fullResUrl;
      if(!fullResLoaded) {
        url = lowResUrl;
      }
      let imgProps = {
        ref: 'img',
        className: className,
        src: url
      };
      return <img {...imgProps} />;
    } else {
      let wrapperProps = {
        ref: 'wrapper',
        className: className,
        style: {
          position: 'relative',
          paddingBottom: Math.round(100 / Number(aspectRatio)) + '%',
          transform: 'translateZ(0)'
        }
      };
      let imgStyles = {
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        transition: this.props.transition,
        borderRadius: this.props.borderRadius
      };
      let fullResImgProps = {
        style: _.extend({
          backgroundImage: `url(${fullResUrl})`,
          opacity: (fullResLoaded ? 1 : 0)
        }, imgStyles)
      };
      let lowResImgProps = {
        style: _.extend({
          backgroundImage: `url(${lowResUrl})`,
          opacity: (!fullResLoaded && lowResLoaded ? 1 : 0)
        }, imgStyles)
      };
      return (
        <div {...wrapperProps} >
          {lowResUrl !== fullResUrl ? <div {...lowResImgProps} /> : null}
          <div {...fullResImgProps} />
          {this.props.children}
        </div>
      );
    }
  }
}

export default Image;



// WEBPACK FOOTER //
// banquet/components/Image/index.js